import utils from '@/utils/utils'
import { loginByUsername, getUserInfo, findToken, loginByMobile, logout } from '@/api/login'
import { getLocalNotLgCarData, removeLocalNotLgCarData } from '@/utils/storage'
import { getToken, setToken, removeToken, removeUserToken } from '@/utils/cookies'

const user = {
  state: {
    userInfo: '',
    token: getToken(),
    isLogin: false,
    host: process.env.CTJZ_PLATFORM_PATH,
    isActive: '0'
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_ISLOGIN: (state, isLogin) => {
      state.isLogin = isLogin
    },          
    SET_ISACTIVE: (state, isActive) => {
      state.isActive = isActive
    }
  },
  actions: {
    // 获取token
    findToken ({ commit }) {
      return new Promise((resolve, reject) => {
        if(getToken()){
          return;
        }

        findToken().then(response => {
          const token = response.data.data
          commit('SET_TOKEN', token)
          setToken(token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      const loginName = userInfo.loginName.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(loginName, userInfo.password).then(response => {
          const data = response.data
          // 说明登录成功了，给vuex设置token，放到Cookie
          const token = data.data
          if (data.errorInfo === 'success' && token !== '') {
            commit('SET_TOKEN', token)
            setToken(token, userInfo.checked)
          } else {
            removeUserToken()
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机号登录
    LoginByMobile ({ commit }, mobileLoginForm) {
      return new Promise((resolve, reject) => {
        loginByMobile(mobileLoginForm.phone, mobileLoginForm.code).then(response => {
          const data = response.data
          const token = data.data
          // 说明登录成功了，给vuex设置token，放到Cookie
          if (data.errorInfo === 'success' && token !== '') {
            commit('SET_TOKEN', token)
            setToken(token, mobileLoginForm.checked)
          } else {
            removeUserToken()
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data
          // console.log("userInfosss", data) //userVIp个人vip  vips机构vip
          let errorInfo = data.errorInfo
          if (errorInfo === 'success') {
            /** 处理vuex中的信息 */
            commit('SET_USERINFO', data.data) // 设置用户信息
            commit('SET_ISLOGIN', true) // 设置登录状态
            // 添加购物车的数据
            let localCarList = getLocalNotLgCarData()
            if (utils.isNotEmpty(localCarList)) {
              for (let itemIndex in localCarList) {
                let item = localCarList[itemIndex]
                let productObj = {
                  productCode: item.productCode,
                  pricePatternId: item.pricePattern.unique,
                  quantity: item.quantity
                }
                dispatch('addCar', productObj).then((res) => {
                }).catch((err) => {
                  console.log(`添加购物车出现异常 ${err}`)
                })
              }
              removeLocalNotLgCarData()
            }
          } else {
            commit('SET_ISLOGIN', false)
            removeUserToken()
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut ({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then((response) => {
          commit('SET_TOKEN', '')
          commit('SET_USERINFO', '')
          commit('SET_ISLOGIN', false)
          removeToken()
          removeUserToken()
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', '')
        commit('SET_ISLOGIN', false)
        removeToken()
        removeUserToken()
        sessionStorage.clear()
        resolve()
      })
    },
    // 导航高亮当前值
    SetIsActice ({ commit }, isActive) {
      return new Promise(resolve => {
        commit('SET_ISACTIVE', isActive)
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js